import React, { useState, useEffect, useCallback } from "react";
import { __bot } from "Utils/Bot/Bot"; // Adjust the import path as necessary
import styles from "./StartChatButton.module.scss"; // Assuming you have a corresponding SCSS file for styling
import { __callbacks } from "../../Utils/Callbacks/Callback";

export default function ButtonStartChat(props: any) {
    const [buttonBlack,] = useState(props.black);
    const [buttonWhite, setButtonWhite] = useState(props.white);
    const [classHover, setClassHover] = useState("");
    const [fill, setFill] = useState("white");

    const initEvents = useCallback(() => {
        // Add any events you want to initialize here
    }, []);

    useEffect(() => {
        if (!buttonBlack && !buttonBlack) {
            setButtonWhite(true);
        }
    }, [buttonBlack, buttonWhite]);

    useEffect(() => {
        if (!buttonBlack) return;
        setFill("black");
        setClassHover(styles["hover-black"]);
    }, [buttonBlack]);

    useEffect(() => {
        if (!buttonWhite) return;
        setFill("white");
        setClassHover(styles["hover-white"]);
    }, [buttonWhite]);

    useEffect(() => {
        initEvents();
    }, [initEvents]);

    const handleClick = () => {
        
        __bot.startChatWithAgent(true);

    };

    return (
        <div className={styles.startChatButtonContainer}>
            <button className={`${styles.startChatButton} config-header-backgroundColor`} onClick={handleClick}>
                Chat with someone
            </button>
        </div>
    );
}
